import React from "react";
import { display, fontSize, maxWidth, styled } from "@mui/system";
import {
  Title, Subtitle, CTASection, CTAText, SuccessMessage, EmailFormWrapper, EmailInput, JoinButton, SectionContainer,
  Description,
  BoxContainer,
  Card,
  CardText
} from "../assets/styles/ContentStyles"
import EmailInputComponent from "./EmailInputComponent";

const WhatHappensNext = () => {

  return (
    <SectionContainer>
      <Title>What happens next</Title>

      <Description>
        We are actively working with the manufacturer to address these security issues.
        In the meantime, here are some steps you can take to protect yourself and
        others on your network:
      </Description>

      <BoxContainer>
        <Card>
          <CardText>
            Use a strong password when accessing and using your device
          </CardText>
        </Card>

        <Card>
          <CardText>
            Update your device with the latest firmware version from the device manufacturer
          </CardText>
        </Card>

        <Card>
          <CardText>
            As new vulnerabilities are discovered by the cybersecurity community, contact the device manufacturer to provide a fix
          </CardText>
        </Card>
      </BoxContainer>

      <CTASection>
        <CTAText>
          Get device security monitoring, patching alerts, and security advice from Hackable Devices.
        </CTAText>

        <EmailInputComponent waitlistType="What Happens Next - Security Monitoring & Patching" />

      </CTASection>
    </SectionContainer>
  );
};

export default WhatHappensNext;
